import { combineReducers } from "redux"
import { database } from './databaseReducer'

const legacyReducers = combineReducers({
    database,
})

export default legacyReducers